export default __webpack_public_path__ + "static/media/liquidity.284128a6.svg";